// extracted by mini-css-extract-plugin
export default {"disclaimer":"Disclaimer-module__disclaimer__mqT5m","link":"Disclaimer-module__link__fL3t1"};